/***
 * @file:
 * @author: caojianping
 * @Date: 2021-05-24 16:42:23
 */
import { DragDropModule } from '@angular/cdk/drag-drop';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';

import { TranslateModule } from '@ngx-translate/core';

import { DtFooterModule } from '@ithinkdt/theme/footer';
import { DtHeaderModule } from '@ithinkdt/theme/header';
import { DtMenuModule } from '@ithinkdt/theme/menu';
import { DtPagesTabModule } from '@ithinkdt/theme/pages-tab';
import { DtSettingDrawerModule } from '@ithinkdt/theme/setting-drawer';

import { IthinkdtThemeComponent } from './ant-design-theme.component';

const ANGULAR_MODULES = [CommonModule, FormsModule, ReactiveFormsModule, RouterModule, DragDropModule];

const THIRD_MODULES = [TranslateModule];

const DT_MODULES = [DtHeaderModule, DtFooterModule, DtMenuModule, DtPagesTabModule, DtSettingDrawerModule];

@NgModule({
  imports: [...ANGULAR_MODULES, ...THIRD_MODULES, ...DT_MODULES],
  declarations: [IthinkdtThemeComponent],
  exports: [IthinkdtThemeComponent],
})
export class DtAntDesignThemeModule {}
